import { render, staticRenderFns } from "./ReviewDone.vue?vue&type=template&id=4fa11b10&scoped=true&"
import script from "./ReviewDone.vue?vue&type=script&lang=js&"
export * from "./ReviewDone.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDone.vue?vue&type=style&index=0&id=4fa11b10&prod&lang=scss&"
import style1 from "./ReviewDone.vue?vue&type=style&index=1&id=4fa11b10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa11b10",
  null
  
)

export default component.exports